import React from 'react';
import { Helmet } from 'react-helmet';
import appBranding from '@happylife-a/branding';

export default function PageTitle({ suffix }) {
  const appName = appBranding.configs.environments.getField(appBranding.fields.brand.AppBranding);

  return (
    <Helmet>
      <title>
        {appName}
        {suffix ? ` | ${suffix}` : ''}
      </title>
    </Helmet>
  );
}
